import { ReactNode, useState } from "react";

import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { exportCommute } from "@/pages/employee/commute/useCommute";

export default function ExportCommuteAction({
  year,
  children,
}: {
  year?: number;
  children: ReactNode;
}) {
  const [open, setOpen] = useState<boolean>(false);

  const onSuccess = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <ActionsPopover
      open={open}
      onOpenChange={handleOpenChange}
      actions={
        <>
          <FileDownloader
            fileOutputName={`export-employee-commute.xlsx`}
            fileUrlFn={() => exportCommute({})}
            onFinish={onSuccess}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export all
              </ActionsPopOverItem>
            )}
            addTimestampAndCompany={true}
          />
          <FileDownloader
            fileOutputName={`export-employee-commute-${year}.xlsx`}
            fileUrlFn={() => exportCommute({ year })}
            onFinish={onSuccess}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export {year}
              </ActionsPopOverItem>
            )}
            addTimestampAndCompany={true}
          />
        </>
      }
    >
      {children}
    </ActionsPopover>
  );
}
